import React, { push, Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Layer,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  List,
  Grid,
  TextInput,
  Select,
  RadioButtonGroup,
  Form,
  CheckBox,
  DateInput,
  FormField,
  CheckBoxGroup,
  Tabs,
  Tab,
  Image,
  CardFooter,
  IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Console,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  CaretDownFill,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Filter,
  Video,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class GetHelpR1 extends Component {
  // const { push } = React.useContext(RouterContext)
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <Layer
        full={true}
        position="center"
        height="medium"
        onClickOutside={this.props.hide}
        onEsc={this.props.hide}
      >
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                basis="xlarge"
                direction="column"
                gap="medium"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/*                 <Button
                  label="Back"
                  icon={<FormPrevious />}
                  onClick={() => push("/gethelp-videos-docs")}
                /> */}
                  <Heading margin="none">Get Help .NULL file extension</Heading>
                </Header>
                <Box
                  align="stretch"
                  justify="center"
                  pad="medium"
                  gap="large"
                  direction="column"
                >
                  <Card hoverIndicator>
                    <CardHeader
                      align="start"
                      direction="column"
                      justify="start"
                      flex
                    >
                      <Box align="center" justify="center" direction="row">
                        <Heading size="small" level="4">
                          The Issue:
                        </Heading>
                      </Box>
                      <Box align="center" justify="center" direction="row">
                        <Paragraph size="medium">
                          Getting .NULL file extension when downloading document
                          using MS EDGE browser
                        </Paragraph>
                        <Image
                          src="/img/GetHelp/GHR1-documentnull.png
"
                          fit="contain"
                        />
                      </Box>
                    </CardHeader>
                    <CardBody
                      direction="column"
                      justify="start"
                      align="stretch"
                    >
                      <Heading size="small" level="4">
                        The Resolution:
                      </Heading>
                      <Paragraph size="medium" textAlign="start" fill>
                        You need to install a PDF reader software on your
                        computer (acrobat or foxit reader for example)
                      </Paragraph>
                      <Paragraph size="medium" textAlign="start" fill>
                        Save file and change extension .pdf
                      </Paragraph>
                      <Paragraph size="medium" textAlign="start" fill>
                        Open your document
                      </Paragraph>
                    </CardBody>
                    <CardFooter
                      align="center"
                      direction="row"
                      flex={false}
                      justify="between"
                      gap="medium"
                      pad="small"
                    >
                      <Text size="xsmall">#GH-R1</Text>
                    </CardFooter>
                  </Card>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}
export default GetHelpR1;
